/**
 * Слежение за версией сборки и мягкая перезагрузка.
 *
 * iOS в режиме «на экран» держит снимок приложения и сам обновления не
 * подтягивает — из-за этого правки не доезжают до установленного PWA (та же
 * беда, что была с кешем в Telegram). Здесь клиент сравнивает свою версию
 * (хеш из имени собственного бандла) с версией на сервере и при расхождении
 * перезагружается — но только в безопасные моменты: на запуске и при возврате
 * приложения на передний план (частый случай для «спящего» iOS-PWA), чтобы не
 * оборвать человека посреди действия.
 */

/** Хеш собственной сборки — из тега <script> которым загрузился этот бандл. */
function myVersion(): string | null {
  const el = document.querySelector<HTMLScriptElement>('script[type="module"][src*="/assets/index-"]')
  return /assets\/index-([A-Za-z0-9_-]+)\./.exec(el?.src ?? '')?.[1] ?? null
}

// Защита от зацикливания: если перезагрузка не помогла (застрявший кеш),
// помним серверную версию, под которую уже перезагружались, и второй раз под
// неё не дёргаемся.
const TARGET_KEY = 'sirr_reload_target'

async function serverVersion(): Promise<string | null> {
  try {
    const r = await fetch('/api/version', { cache: 'no-store' })
    if (!r.ok) return null
    const d = (await r.json()) as { version?: string }
    return typeof d.version === 'string' && d.version ? d.version : null
  } catch {
    return null
  }
}

async function check(mine: string): Promise<void> {
  const sv = await serverVersion()
  if (!sv) return
  if (sv === mine) {
    sessionStorage.removeItem(TARGET_KEY) // всё свежее — снимаем защиту
    return
  }
  // Есть новая сборка. Если под неё уже перезагружались, а всё равно старьё —
  // не зацикливаемся (переживём до следующего запуска).
  if (sessionStorage.getItem(TARGET_KEY) === sv) return
  sessionStorage.setItem(TARGET_KEY, sv)
  location.reload()
}

export function startVersionWatch(): void {
  const mine = myVersion()
  if (!mine) return // не смогли определить свою версию — молчим, чтобы не навредить

  // На запуске — с небольшой задержкой, чтобы не мешать первой отрисовке.
  window.setTimeout(() => void check(mine), 1500)

  // При возврате на передний план — здесь и ловим «проснувшийся» iOS-PWA.
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') void check(mine)
  })
}
